import { Theme } from "../../../../media/themeTypes";

export const optionIconStyles = (theme: Theme) => ({
  color: theme?.TEXT_COLOR,
});
